import { render, staticRenderFns } from "./dashboardcount.vue?vue&type=template&id=0e4493db&"
import script from "./dashboardcount.vue?vue&type=script&lang=js&"
export * from "./dashboardcount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports